import { Box, IconButton, Typography, styled, Button } from "@mui/material";
import { APP_COLOR, APP_HOVER_COLOR, FONT_FAMILY } from "../../theme";

export const styles = {
  libraryContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "0px 20px 5px",
    fontFamily: FONT_FAMILY,
    margin: "40px 0",
  } as const,
  headerContainer: {
    display: "flex",
    alignSelf: "center",
  } as const,
  header: {
    fontSize: 28,
    margin: "20px 0 40px",
    fontWeight: "bold",
    textAlign: "center",
  } as const,
  linearProgressContainer: {
    width: "100%",
    color: APP_COLOR,
    height: "50vh",
    paddingTop: 20,
  } as const,
  ownerLabelStyle: {
    marginLeft: "10px",
    textDecoration: "none",
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
  } as const,
  tableHeader: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  } as const,
  nameContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: 140,
    marginRight: 90,
  } as const,
  dateContainer: {
    marginLeft: 70,
    marginRight: 60,
    display: "flex",
    alignItems: "center",
  } as const,
  fileSizeContainer: {
    marginRight: 250,
    display: "flex",
    alignItems: "center",
  } as const,
  filtersContainer: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
  } as const,
  button: {
    height: 50,
    width: 190,
    marginBottom: "20px",
    color: "black",
    backgroundColor: APP_COLOR,
    fontWeight: "bold",
    fontSize: "16px",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
  } as const,
};

export const VersionDetailsBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "left",
  width: "auto",
  padding: "5px 2px 5px 2px",
  borderBottom: "4px solid #9FA4A9",
  margin: "5px 2px 5px 2px",
  [theme.breakpoints.down("md")]: {
    fontSize: 13,
  },
}));

export const TypeBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginLeft: "160px",
  [theme.breakpoints.down("md")]: {
    marginLeft: "0px",
  },
}));

export const LabelBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginLeft: "150px",
  [theme.breakpoints.down("lg")]: {
    marginLeft: "0px",
    marginRight: "-100px",
  },
}));

export const LabelDateBox = styled(Box)(({ theme }) => ({
  display: "flex",
  whiteSpace: "nowrap",
  overflow: "hidden",
  width: "calc(100%)",
  textOverflow: "ellipsis",
  fontSize: 15,
  alignItems: "center",
  justifyContent: "space-around",
  marginRight: 95,
  [theme.breakpoints.down("lg")]: {
    marginRight: 50,
  },
}));

export const FileSizeHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  whiteSpace: "nowrap",
  alignItems: "center",
  fontWeight: "bold",
  justifyContent: "flex-start",
  textAlign: "center",
  marginRight: 2,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const NameHeader = styled(Typography)(({ theme }) => ({
  display: "flex",
  fontFamily: FONT_FAMILY,
  fontWeight: "bold",
  marginRight: 4,
  justifyContent: "center",
  [theme.breakpoints.down("md")]: {
    marginLeft: 60,
    marginRight: 0,
    fontSize: 12,
    justifyContent: "flex-start",
  },
}));

export const DateHeader = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  textAlign: "center",
  fontWeight: "bold",
  marginRight: 4,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const LabelHeader = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  textAlign: "center",
  fontWeight: "bold",
  marginRight: 4,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const TypeHeader = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  textAlign: "center",
  fontWeight: "bold",
  marginRight: 4,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const ResponsiveArrow = styled(IconButton)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const AddFileButton = styled(Button)(({ theme }) => ({
  marginRight: 20,
  boxShadow: "0 5px 25px 0 rgba(0, 0, 0, 0.6)",
  borderRadius: 5,
  height: 45,
  width: 190,
  color: "black",
  fontWeight: "bold",
  "&:hover": {
    backgroundColor: APP_HOVER_COLOR,
  },
  backgroundColor: APP_COLOR,
  textTransform: "none",
  fontSize: 16,
  fontFamily: FONT_FAMILY,
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    marginRight: 0,
    marginBottom: 25,
  },
}));

export const TopContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));
